export const CURRENT_CLIENT_CONTACTS_MODAL_NAME = 'currentClientContacts';
